





























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import StaffReviewCard from '~/components/pages/Staff/StaffReviewCard.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { STAFF_REVIEW_ANCHOR_POINT } from '~/constants';
import { url } from '~/utils';
import { StaffReview } from '~/types/modules/staff';

export default defineComponent({
  components: {
    AppIcon,
    AppLink,
    StaffReviewCard,
  },
  props: {
    productCode: {
      type: String,
      required: true,
    },
    staffReviewResponse: {
      type: Array as PropType<StaffReview[]>,
      required: true,
    },
  },
  setup() {
    return { url, STAFF_REVIEW_ANCHOR_POINT };
  },
});
